// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__caJl6","pink":"About_pink__mYuAN","green":"About_green__QplAC","skills":"About_skills__DYBZo"};